export default __webpack_public_path__ + "static/media/thum_twently_one.99bab528.png";